import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CountryDto } from 'src/app/data-transfer/entities/country-dto';
import { CompanyDto } from 'src/app/data-transfer/entities/doc-entities/company-dto';
import { DocProfileDto } from 'src/app/data-transfer/entities/doc-entities/doc-profile-dto';
import { DialogActions } from 'src/app/model/dictionary';

export class PpwrProducerDialogData {
  constructor(
    public readonly title: string,
    public readonly icon: string,
    public readonly countries: CountryDto[] = [],
    public readonly producer?: CompanyDto,
    public readonly docProfiles: DocProfileDto[] = [],
    public readonly showDocProfileField: boolean = true
  ) {}

  get isEditMode(): boolean {
    return !!this.producer;
  }
}

@Component({
  selector: 'app-ppwr-producer-dialog',
  templateUrl: './ppwr-producer-dialog.component.html',
  styleUrls: ['./ppwr-producer-dialog.component.scss'],
})
export class PpwrProducerDialogComponent {
  readonly noDocProfileId = '';

  form: FormGroup;
  title: string;
  icon: string;
  countries: CountryDto[] = [];
  docProfiles: DocProfileDto[] = [];
  isEditMode = false;
  showDocProfileField = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: PpwrProducerDialogData,
    private dialogRef: MatDialogRef<PpwrProducerDialogComponent>,
    private formBuilder: FormBuilder
  ) {
    this.title = dialogData.title;
    this.icon = dialogData.icon;
    this.countries = dialogData.countries ?? [];
    this.docProfiles = dialogData.docProfiles ?? [];
    this.isEditMode = dialogData.isEditMode;
    this.showDocProfileField = dialogData.showDocProfileField;

    this.form = this.formBuilder.group({
      companyName: [dialogData.producer?.companyName ?? '', Validators.required],
      address: [dialogData.producer?.address ?? '', Validators.required],
      postCode: [dialogData.producer?.postCode ?? '', Validators.required],
      city: [dialogData.producer?.city ?? '', Validators.required],
      location: [dialogData.producer?.location ?? '', Validators.required],
      defaultDocProfileId: [dialogData.producer?.defaultDocProfileId ?? this.noDocProfileId],
    });
  }

  doAction(): void {
    this.form.markAllAsTouched();

    if (this.form.invalid) {
      return;
    }

    const defaultDocProfileId = this.form.value.defaultDocProfileId;
    this.dialogRef.close({
      event: DialogActions.CONFIRM,
      data: { ...this.form.value, defaultDocProfileId: defaultDocProfileId === this.noDocProfileId ? null : defaultDocProfileId },
    });
  }

  closeDialog(): void {
    this.dialogRef.close({ event: DialogActions.REJECT });
  }
}
